import React from 'react';
import { confirmable } from 'react-confirm';
import { Modal, Header, Button, Icon, Input } from 'semantic-ui-react';

class Dialog extends React.Component{
  constructor(props) {
    super(props);
    this.state = { value: '' };
  }

  complete = () => {
    this.props.onComplete(this.state.value);
    this.props.proceed();
  }

  render() {
    const { show, dismiss, title, prompt } = this.props;
    const { value } = this.state;
    return (
      <Modal open={show} onClose={dismiss} basic size='small'>
        <Header content={title} />
        <Modal.Content>
          {prompt}
        </Modal.Content>
        <Modal.Content>
          <Input fluid value={value} onChange={e => this.setState({ value: e.target.value })} />
        </Modal.Content>
        <Modal.Actions>
          <Button basic color='red' inverted onClick={dismiss}>
            <Icon name='remove' /> Cancel
          </Button>
          <Button color='green' inverted onClick={this.complete}>
            <Icon name='checkmark' /> OK
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
};

export default confirmable(Dialog);
